import { memo } from "react";
import clsx from "clsx";
import { Grid } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

import { View } from "../../View";
import { palette } from "../../../theme/palette";

const useStyles = makeStyles({
  labelContainer: {
    minWidth: "26px",
    height: "26px",
    lineHeight: "26px",
    fontSize: "0.75rem",
    textAlign: "center",
    borderRadius: "0.125rem",
    fontWeight: "bold",
    color: "white",
    position: "relative",
    padding: "0 1px",
    whiteSpace: "nowrap",
  },
  container: {
    minHeight: "30px",
    background: "white",
    borderRadius: "4px",
    marginRight: "10px",
    boxShadow: `0px 2px 3px ${palette.typography.black.high}`,
    flexWrap: "nowrap",
    cursor: "default",
  },
  pointerCursor: {
    cursor: "pointer",
  },
  spacing: {
    padding: "2px",
    flexWrap: "nowrap",
  },
});

export const PostcodeLabel = memo(
  ({ postcode, colour, textColour, onClick }) => {
    const styles = useStyles();

    return (
      <Grid
        container
        className={clsx(styles.container, onClick && styles.pointerCursor)}
        onClick={(e) => {
          e.stopPropagation();
          onClick && onClick({ postcode });
        }}
      >
        <Grid item xs={12} className={styles.spacing}>
          <View
            style={{
              background: colour || "black",
              color: textColour || palette.typography.white.high,
            }}
            className={styles.labelContainer}
          >
            {postcode}
          </View>
        </Grid>
      </Grid>
    );
  }
);
